import ApiService from "@/api/ApiService";
import MaterialEditor from "@/components/planning/dialogs/newMaterialOrder/MaterialEditor";
import { MaterialOrder } from "@/components/planning/Project";
import ConfirmDialog from "@/shared/dialogs/ConfirmDialog";
import { Delete, Edit, ManageSearch, MyLocation } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Fragment } from "react";
import { dispoCalJobQueryKey } from "./CalendarListView";

type SingleJobMaterialOrder = MaterialOrder & { job: number };

export function DirectMaterialEditor({
  job,
  region,
  project,
  date,
  order,
  setModalOpen,
}: {
  job: number;
  date: string;
  region: number;
  project: number;
}) {
  const queryClient = useQueryClient();

  const saveMutation = useMutation<SingleJobMaterialOrder, AxiosResponse, SingleJobMaterialOrder>({
    mutationFn: ApiService.editEntity("materialOrder"),
    onSuccess: (answer) => {
      const inval = dispoCalJobQueryKey(job);
      console.log("invalidate", inval);
      queryClient.invalidateQueries({
        queryKey: inval,
      });
      queryClient.invalidateQueries({ queryKey: ["getJobApp", "" + job] });
    },
  });

  return true ? (
    <Fragment>
      {!!setModalOpen ? (
        <Fragment>
          <IconButton size="small" onClick={() => setModalOpen(["HISTORY", order.id])}>
            <ManageSearch fontSize="small" />
          </IconButton>
          <IconButton size="small" onClick={() => setModalOpen(["LOCATION", order.id])}>
            <MyLocation fontSize="small" />
          </IconButton>
        </Fragment>
      ) : null}
      <MaterialEditor
        jobId={job}
        projectId={project}
        saveType="DIRECT"
        invalidate={(answer) => {
          const inval = dispoCalJobQueryKey(job);
          console.log("invalidate", inval);
          queryClient.invalidateQueries({
            queryKey: inval,
          });
          queryClient.invalidateQueries({ queryKey: ["getJobApp", "" + job] });
        }}
        Opener={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Edit fontSize="small" />
          </IconButton>
        )}
        initialState={order}
      />

      <ConfirmDialog
        CustomButton={({ onClick }) => (
          <IconButton size="small" onClick={onClick}>
            <Delete fontSize="small" />
          </IconButton>
        )}
        title={"Wirklich löschen?"}
        confirmText={"Bitte bestätige die Löschung."}
        onAccept={() => saveMutation.mutate({ ...order, job, deleted: true })}
      />
    </Fragment>
  ) : null;
}
